import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  CardMedia,
  Tooltip,
  IconButton,
  InputBase,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../../main/detail/Detail";
import {
  rsActiveMenu,
  rsProgress,
  rsParentCom,
} from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingHero } from "./UseLandingHero";
import { UseMyPC } from "../../../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import { deCapitalizeFirstLetter } from "../../../../util/Utils";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Container, Draggable } from "react-smooth-dnd";
import { arrayMove } from "react-sortable-hoc";
import CloseIcon from "@mui/icons-material/Close";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import CheckIcon from "@mui/icons-material/Check";
import IsSlideTrue from "./IsSlideTrue";
import ClearIcon from "@mui/icons-material/Clear";
import HttpsIcon from "@mui/icons-material/Https";

export default function Landinghero(props) {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    GetLandingHero,
    updateLandingHero,
    deleteLandingHero,
    RotateHomepageLandingHero,
  } = UseLandingHero();
  const navigate = useNavigate();
  const [removedIndex, setRemovedIndex] = useState();
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });
  const { myPc, goToFirstPage, updatePage, updateSort, setScrollTo, refresh } =
    UseMyPC("Id", "Desc");
  const [slides, setSlides] = useState();
  const [search, setSearch] = useState("");
  const [sendModel, setSendModel] = useState();
  const [sideModel, setSideModel] = useState();

  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  function handleSearch(value) {
    setScrollTo(undefined);
    setSearch(value);
  }

  const onDrop = ({ removedIndex, addedIndex }) => {
    const updater = (items) =>
      arrayMove(items, removedIndex, addedIndex).map((item, idx) => {
        return { ...item, rowIndex: idx + 1 };
      });
    setRemovedIndex(addedIndex + 1);
    setSendModel(updater);
  };

  useEffect(() => {
    if (sendModel && removedIndex) {
      let send = {
        Id: "",
        RowIndex: "",
        isActive: true,
        startDate: undefined,
        endDate: undefined,
      };
      let newModel = sendModel.find((m) => m.rowIndex == removedIndex);
      send.Id = newModel.id;
      send.RowIndex = sendModel.length - newModel.rowIndex + 1;
      send.isActive = newModel.isActive;
      send.startDate = newModel.startDate;
      send.endDate = newModel.endDate;
      updateLandingHero(send, "", "", "", (call) => {
        refresh();
        setRemovedIndex(undefined);
      });
    }
  }, [removedIndex]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetLandingHero(search, myPc, location.state.SlideID, (callback) => {
      var newtemp = [];
      var newtemp2 = [];
      callback.activeSlides?.map((model) => {
        if (model.isSide) {
          newtemp.push(model);
        } else {
          newtemp2.push(model);
        }
      });
      setSideModel(newtemp.reverse());
      setSendModel(newtemp2.reverse());

      // setSendModel(callback.activeSlides.reverse());
      setSlides(callback);
    });
  }, [myPc]);

  const newFunc = () => {
    return navigate("addLandingHero", {
      state: {
        myPc: myPc,
        search: search,
        SlideID: location.state.SlideID,
        componentFaTitle: location.state.componentFaTitle,
        ComponentID: location.state?.ComponentID,
      },
    });
  };

  const newFuncRotate = () => {
    setProgress(true);
    RotateHomepageLandingHero((cdd) => {
      GetLandingHero(search, myPc, location.state.SlideID, (callback) => {
        var newtemp = [];
        var newtemp2 = [];
        callback.activeSlides?.map((model) => {
          if (model.isSide) {
            newtemp.push(model);
          } else {
            newtemp2.push(model);
          }
        });
        setSideModel(newtemp.reverse());
        setSendModel(newtemp2.reverse());

        setSlides(callback);
      });
      setProgress(false);
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان هدر",
      width: 300,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "isSide",
      // field: "هدر کناری",
      // sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      hide:
        location.state?.ComponentID == 14 || location.state?.ComponentID == 45
          ? false
          : true,
      headerName: "هدر کناری",
      renderCell: (cellValues) => {
        return (
          <>
            {cellValues.row.isSide ? (
              <IconButton>
                <CheckIcon fontSize="small" sx={{ color: "green" }} />
              </IconButton>
            ) : (
              ""
            )}
          </>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 120,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("editLandingHero", {
                    state: {
                      myPc: myPc,
                      search: search,
                      SlideID: location.state.SlideID,
                      oneSlideID: cellValues.row.id,
                      componentFaTitle: location.state.componentFaTitle,
                      ComponentID: location.state?.ComponentID,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="اکران">
              {cellValues.row.isActive ? (
                <span>
                  <IconButton
                    onClick={() => {
                      deleteLandingHero(cellValues.row.id, () => refresh());
                    }}
                  >
                    <CloseIcon fontSize="small" sx={{ color: "red" }} />
                  </IconButton>
                </span>
              ) : (
                <span>
                  <IconButton
                    onClick={() => {
                      let send = {
                        Id: cellValues.row.id,
                        isActive: true,
                      };
                      setOpenDialog({ show: true, model: send });
                    }}
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </span>
              )}
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={search ? search : ""}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                handleSearch(evt.target.value);
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: msParentCom.parentComs,
          },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/landinghero",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          آیا از اکران هدر اطمینان دارید ؟
        </DialogTitle>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() =>
              updateLandingHero(openDialog.model, "", "", "", (call) => {
                setOpenDialog({ ...openDialog, show: false });
                refresh();
              })
            }
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ height: "100%", pb: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography color="secondary" variant="subtitle1">
            هدر فعال
          </Typography>
          {sendModel && sendModel.length ? (
            <Container
              onDrop={onDrop}
              orientation="horizontal"
              behaviour="move"
              style={{
                width: "100% !important",
                direction: "ltr",
                display: "flex",
                justifyContent: "flex-end",
              }}
              dropPlaceholder={{
                animationDuration: 150,
                showOnTop: true,
                className: "cards-drop-preview",
              }}
            >
              {sendModel.map((model, i) => {
                return (
                  <Draggable
                    key={model.id}
                    style={{
                      width: "10%",
                      cursor: "grab",
                    }}
                    order={model.rowIndex}
                  >
                    <Box
                      sx={{
                        mb: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          border: "1px solid #d9d9d9",
                          borderRadius: 3,
                          position: "relative",
                          my: 1,
                          p: 1,
                          pb: 0,
                          mr: 1,
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <LazyLoadImage
                          height="auto"
                          effect="blur"
                          src={
                            model.image2
                              ? model.image2
                              : "/static/img/nobanner.png"
                          }
                          width="100%"
                        />
                        {model.isFix && (
                          <Box
                            sx={{
                              position: "absolute",
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              zIndex: 1000,
                              right: -5,
                              top: -5,
                              width: "100% !important",
                              height: "100%",
                              m: 1,
                            }}
                          >
                            <HttpsIcon
                              // fontSize="small"
                              sx={{
                                bgcolor: "primary.main",
                                borderRadius: 50,
                                color: "#fff",
                                cursor: "pointer",
                                p: 0.4,
                              }}
                            />
                          </Box>
                        )}
                        <Box
                          sx={{
                            position: "absolute",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            zIndex: 1000,
                            left: 5,
                            width: "100% !important",
                            height: "100%",
                            m: 1,
                          }}
                        >
                          <EditIcon
                            onClick={() => {
                              return navigate("editLandingHero", {
                                state: {
                                  myPc: myPc,
                                  search: search,
                                  SlideID: location.state.SlideID,
                                  oneSlideID: model.id,
                                  componentFaTitle:
                                    location.state.componentFaTitle,
                                  ComponentID: location.state?.ComponentID,
                                },
                              });
                            }}
                            // fontSize="small"
                            sx={{
                              bgcolor: "secondary.main",
                              borderRadius: 50,
                              color: "#fff",
                              cursor: "pointer",
                              p: 0.4,
                              ml: 0.5,
                            }}
                          />
                          <ClearIcon
                            onClick={() =>
                              deleteLandingHero(model.id, () => refresh())
                            }
                            sx={{
                              bgcolor: "secondary.main",
                              borderRadius: 50,
                              color: "#fff",
                              cursor: "pointer",
                              p: 0.4,
                            }}
                          />
                        </Box>
                      </Box>
                      <Typography variant="subtitle2">{model.id}</Typography>
                    </Box>
                  </Draggable>
                );
              })}
            </Container>
          ) : (
            <Box
              width="100px"
              height="100px"
              sx={{
                border: "1px solid #d9d9d9",
                p: 1,
                borderRadius: 3,
                my: 1,
                mb: 3,
                mr: 1,
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <CardMedia
                width="100%"
                component="img"
                image="/static/img/nobanner.png"
              />
            </Box>
          )}
        </Box>
        {(location.state?.ComponentID == 14 ||
          location.state?.ComponentID == 45) && (
          <Box>
            <IsSlideTrue
              setSideModel={setSideModel}
              sideModel={sideModel}
              callback={() => {
                refresh();
              }}
            />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "70%",
            pb: 2,
          }}
        >
          <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
            هدرها
          </Typography>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={
              slides && slides.pageCondition
                ? slides.pageCondition.pageCount
                : 1
            }
            rows={slides && slides.slides ? slides.slides : []}
            paginationMode="server"
            page={
              slides && slides.pageCondition ? slides.pageCondition.page - 1 : 1
            }
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              slides && slides.pageCondition
                ? slides.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                scrollTo: myPc.scrollTo,
                newFunc: newFunc,
                newFuncRotate: newFuncRotate,
                isLtr: true,
                rowCount:
                  slides && slides.pageCondition
                    ? slides.pageCondition.totalItemCount
                    : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: deCapitalizeFirstLetter(myPc.sortColumn),
                    sort: deCapitalizeFirstLetter(myPc.sortOrder),
                  },
                ],
              },
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc",
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        </Box>
      </Box>
    </Detail>
  );
}
